import { FormikErrors, setNestedObjectValues } from "formik";
import { IAddBMDProperty } from "../Interfaces";
import { getHistoryItemId, getISODateString } from ".";
import { appInsights } from "us.helper";

/**
 * @function
 * @description - To get a synthetic form validation on adding new change history value
 * @param {(values?: IAddBMDProperty) => Promise<FormikErrors<IAddBMDProperty>>} validateForm - formik function to validate form
 * @param {IAddBMDProperty} values - the form values
 * @param {*} setValues - formik function to set values
 * @param {(fields: { [field: string]: boolean }, shouldValidate?: boolean) => void} setTouched - formik funciton to get the fields touched
 */
export const handleAddValueToHisotryButton = (
  validateForm: (
    values?: IAddBMDProperty
  ) => Promise<FormikErrors<IAddBMDProperty>>,
  values: IAddBMDProperty,
  setValues: any,
  setTouched: (
    fields: { [field: string]: boolean },
    shouldValidate?: boolean
  ) => void,
  currentUserEmail: string
): void => {
  try {
    validateForm({ ...values, isAddButtonClicked: true }).then(
      (validationErrors) => {
        if (Object.keys(validationErrors).length === 0) {
          const historyValues = [...(values.changedHistory ?? [])];
          historyValues?.unshift({
            comment: values.comment,
            dateTime: getISODateString(values.fromDate ?? undefined) ?? "",
            isEffective: false,
            isNew: true,
            user: currentUserEmail,
            id: getHistoryItemId(values.changedHistory ?? []),
            value: values.value,
          });
          setValues(
            (preValues: IAddBMDProperty) => ({
              ...preValues,
              changedHistory: historyValues,
              comment: "",
              fromDate: undefined,
              value: undefined,
            }),
            false
          );
        } else {
          setTouched(setNestedObjectValues(validationErrors, true), false);
        }
      }
    );
  } catch (error) {
    appInsights.trackException(
      `Error in add BMD handleAddValueToHisotryButton function. - ${error}`
    );
  }
};
